// extracted by mini-css-extract-plugin
export default {"wrapper":"InstructionConfig_wrapper__7ONiw"};